import { lazy } from 'react';

type ComponentImportType = () => Promise<{ default: React.ComponentType }>;

const sessionKey = 'lazyWithRetry';

export const LazyWithRetry = (componentImport: ComponentImportType) => {
  return lazy(async () => {
    const hasRefreshed =
      globalThis.sessionStorage.getItem(sessionKey) || 'false';

    try {
      if (!window.location.href.includes('timestamp=')) {
        // If the URL already contains a query string, do not not reset the session storage
        globalThis.sessionStorage.setItem(sessionKey, 'false');
      }
      return await componentImport();
    } catch (error) {
      console.log('Error loading component, retrying...', hasRefreshed, error);
      if (hasRefreshed === 'false') {
        globalThis.sessionStorage.setItem(sessionKey, 'true');
        window.location.href =
          window.location.href + '?timestamp=' + new Date().getTime();
      }

      if (hasRefreshed === 'true') throw new Error('chunkLoadError');
    }
  });
};

export default LazyWithRetry;
